import { useContext } from "react";

import { ToastContext, ToastProps } from "@/shared/contexts";

type ToastOptionsProps = Omit<ToastProps, "severity">;

export const useToast = (): {
    successToast: (options: ToastOptionsProps) => void;
    errorToast: (options: ToastOptionsProps) => void;
    warningToast: (options: ToastOptionsProps) => void;
    infoToast: (options: ToastOptionsProps) => void;
    closeToast: () => void;
} => {
    const { openToast, closeToast } = useContext(ToastContext);

    const successToast = (options: ToastOptionsProps) => {
        openToast({
            ...options,
            severity: "success",
        });
    };

    const errorToast = (options: ToastOptionsProps) => {
        openToast({
            ...options,
            severity: "error",
        });
    };

    const warningToast = (options: ToastOptionsProps) => {
        openToast({
            ...options,
            severity: "warning",
        });
    };

    const infoToast = (options: ToastOptionsProps) => {
        openToast({
            ...options,
            severity: "info",
        });
    };

    return {
        successToast,
        errorToast,
        warningToast,
        infoToast,
        closeToast,
    };
};
